import axios from "axios";
import toastr from "toastr";

//apply base url for axios
const API_URL = "";

axios.defaults.withCredentials = true

const axiosApi = axios.create({
  baseURL: API_URL,
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const custom_config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Accept": "application/json",
    "X-CSRF-TOKEN": getCookie('csrf_access_token')
  }
};

const custom_form_data_config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Accept": "application/json",
    "Content-Type": "multipart/form-data",
    "X-CSRF-TOKEN": getCookie('csrf_access_token')
  }
}

toastr.options.preventDuplicates = true;

const setupInterceptor = (handleNavigation) => {
  let isSessionExpiredToastDisplayed = false;
  toastr.options.preventDuplicates = true;
  let nextUrl = location.pathname;
  axiosApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && error.response.data.message === "Token has expired") {
        if (!isSessionExpiredToastDisplayed) {
          toastr.error("Your session has expired. Please login again.");
          isSessionExpiredToastDisplayed = true;
        }
        setTimeout(() => {
          localStorage.removeItem("authUser");
          window.location.href = "/login?next=" + nextUrl;
        }, 3000);
      } else if (error.response && error.response.status === 401) {

        if (error.response.data.message === "Token is invalid") {
          toastr.error(error.response.data.message);
          setTimeout(() => {
            localStorage.removeItem("authUser");
            window.location.href = "/login?next=" + nextUrl;
          }, 3000)
        }

        if (error.response.data.message === "Token is unauthorized") {
          toastr.error(error.response.data.message);
          setTimeout(() => {
            localStorage.removeItem("authUser");
            window.location.href = "/login?next=" + nextUrl;
          }, 3000)
        }

        if (error.response.request.responseURL.includes("logout")) {
          localStorage.removeItem("authUser");
          window.location.href = "/login?next=" + nextUrl;
        } else if (error.response.data.message) {
          toastr.error(error.response.data.message);
        } else {
          toastr.error("You are not authorized to access this page.");
        }
      } else if (error.response && error.response.status === 400) {
        if (error.response.data.message) {
          toastr.error(error.response.data.message);
        }
      } else if (error.response && error.response.status >= 402 && error.response.status < 500) {
        toastr.error("Something went wrong. Our team has been notified about the issue. Please try again later.");
      } else if (error.response && error.response.status >= 500) {
        toastr.error("Something went wrong. Our team has been notified about the issue. Please try again later.");
      }
      return Promise.reject(error);
    }
  );
}

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, {...custom_config})
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, {...data}, {...custom_config})
    .then((response) => response.data);
}

export async function postFormData(url, data, config = {}) {
  return axiosApi
    .post(url, data, {...custom_form_data_config})
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, {...data}, {...custom_config})
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, {...config})
    .then((response) => response.data);
}

export async function postStreaming(url, data, config = {}) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...custom_config.headers,
    },
    body: JSON.stringify(data),
    ...config
  });
}

export default setupInterceptor;
